import { bootstrap } from "@erp/shared/bootstrap";
import { POWERNIX_ERP_INFO } from "./const/erp-info.const";
import App from "./App.vue";
bootstrap({
    erpInfo: POWERNIX_ERP_INFO,
    routerImport: () => import("./router/index"),
    App,
});
